import * as React from 'react';
import { ContextualHelp } from '@digital/react-aviva-atom';
import './ContextualHelp.css';

/**
 * state for the desktop view content
 */
export interface ContextualHelpContainerState {
    desktopContentVisible?: boolean;
}

/**
 * state for the mobile view content
 */
export interface ContextualHelpContentState {
    callUsContentVisible?: boolean;
    linksContentVisible?: boolean;
    faqContentVisible?: boolean;
}

export interface ContextualHelpContentProps {
    desktopContentVisible?: boolean;
}

const CALL_US = 'Call Us';
const FAQS = 'Frequently asked questions';
const LINKS = 'Links'

export class ContextualHelpContentDrivingSchool extends React.PureComponent<ContextualHelpContentProps, ContextualHelpContentState> {

    constructor(props: ContextualHelpContentProps) {
        super(props);
        this.state = {
            callUsContentVisible: false,
            linksContentVisible: false,
            faqContentVisible: false,
        };
    }

    handleSectionClick = (section: string) => {
        switch (section) {
            case CALL_US:
                this.setState({ callUsContentVisible: !this.state.callUsContentVisible });
                break;
            case FAQS:
                this.setState({ faqContentVisible: !this.state.faqContentVisible });
                break;
            case LINKS:
                this.setState({ linksContentVisible: !this.state.linksContentVisible });
                break;
            default:
                break;
        }
    };

    render() {
        const { desktopContentVisible } = this.props;
        return (
            <React.Fragment>
                <ContextualHelp.Content
                    type="chat"
                    text={CALL_US}
                    className="contentPointer"
                    onClick={() => this.handleSectionClick(CALL_US)}
                    desktopContentVisible={desktopContentVisible}
                >
                    <p className="a-heading a-heading--2 a-heading--light"><strong>1800 663663</strong></p>
                    <dl className="a-list-opening-times">
                        <dt className="a-list-opening-times__days">Monday to Friday</dt>
                        <dd className="a-list-opening-times__hours">9.00am - 5.30pm</dd>
                    </dl>
                </ContextualHelp.Content>
                <ContextualHelp.Content
                    type="call"
                    text={LINKS}
                    className="contentPointer"
                    onClick={() => this.handleSectionClick(LINKS)}
                    desktopContentVisible={desktopContentVisible}
                >
                    <ul className="a-list-plain">
                        <li>
                            <a
                                href="http://www.aviva.ie/driving-school/terms/"
                                target="_blank"
                                rel="noreferrer"
                                {...(desktopContentVisible || this.state.linksContentVisible ? {} : { tabIndex: -1 })}
                            >
                                Driving School Terms and Conditions
                            </a>
                        </li>
                    </ul>
                </ContextualHelp.Content>
                <ContextualHelp.Content
                    type="faq"
                    text={FAQS}
                    className="contentPointer"
                    onClick={() => this.handleSectionClick(FAQS)}
                    desktopContentVisible={desktopContentVisible}
                >
                    <ul className="a-list-plain">
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="http://www.aviva.ie/driving-school/faqs/#getting-started"
                                {...( desktopContentVisible || this.state.faqContentVisible ? {} : { tabIndex: -1 })}
                            >
                                Getting Started
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="http://www.aviva.ie/driving-school/faqs/#accompanied-cover"
                                {...(desktopContentVisible || this.state.faqContentVisible ? {} : { tabIndex: -1 })}
                            >
                                Free Accompanied Driver Cover
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="http://www.aviva.ie/driving-school/faqs/#your-lessons"
                                {...(desktopContentVisible || this.state.faqContentVisible ? {} : { tabIndex: -1 })}
                            >
                                Your Lessons
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="http://www.aviva.ie/driving-school/faqs/#paying-lessons"
                                {...(desktopContentVisible || this.state.faqContentVisible ? {} : { tabIndex: -1 })}
                            >
                                Paying for Lessons
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="http://www.aviva.ie/driving-school/faqs/#gift-vouchers"
                                {...(desktopContentVisible || this.state.faqContentVisible ? {} : { tabIndex: -1 })}
                            >
                                Gift Vouchers
                            </a>
                        </li>
                        <li>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="http://www.aviva.ie/driving-school/faqs/#important-information"
                                {...(desktopContentVisible || this.state.faqContentVisible ? {} : { tabIndex: -1 })}
                            >
                                Important Information
                            </a>
                        </li>
                    </ul>
                </ContextualHelp.Content>
            </React.Fragment>
        );
    }
}

export class ContextualHelpDrivingSchool extends React.PureComponent<{}, ContextualHelpContainerState> {

    constructor(props: {}) {
        super(props);
        this.state = {
            desktopContentVisible: false,
        };
    }

    onClick = () => {
        this.setState({ desktopContentVisible: !this.state.desktopContentVisible });
    };

    render() {
        return (
            <div>
                <ContextualHelp.Container scroll={true} scrollAlign="top">
                    <ContextualHelp.Header  onClick={this.onClick}>
                        <ContextualHelp.Link className="ds-contextual-help-h2">
                            <ContextualHelp.HeaderGroup>
                                Contact Us
                            </ContextualHelp.HeaderGroup>
                            <ContextualHelp.HeaderGroup>
                                Links
                            </ContextualHelp.HeaderGroup>
                            <ContextualHelp.HeaderGroup>
                                FAQ
                            </ContextualHelp.HeaderGroup>
                        </ContextualHelp.Link>
                    </ContextualHelp.Header>
                    <ContextualHelp.ContentGroup>
                        <ContextualHelpContentDrivingSchool desktopContentVisible={this.state.desktopContentVisible} />
                    </ContextualHelp.ContentGroup>
                </ContextualHelp.Container>
            </div>
        );
    }
}